var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/well-known-symbol-wrapped.js
// module id = 497
// module chunks = 0